package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAndroid2017YearInReviewPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/Android2017YearInReview.md", FrontMatterElement.Builder { addScalar("title", "2017 year in a review: Android"); addScalar("date", "2017-12-31"); addScalar("description", "2017 was an amazing year for Android. A lot of big announcements happened this year in Android from adding a new language support — Kotlin for happier Android Development to…"); addScalar("originalUrl", "https://proandroiddev.com/2017-year-in-a-review-android-5f2cd8738790"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/2017-year-in-a-review-android/1Yl4XFt2IW5_mHB5qJcL6_Q.webp"); }))
}

@Page("/articles/android2017-year-in-review")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun Android2017YearInReviewPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("2017 was an amazing year for Android. A lot of big announcements happened this year in Android from adding a new language support — Kotlin for happier Android Development to Neural network API and ARCore to build smart and interactive apps.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Let’s quickly recap all the notable announcements happened in 2017 for Android from ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Android Developer’s point of view")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1Yl4XFt2IW5_mHB5qJcL6_Q.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Photo by ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/photos/SD2FxgKDAGk?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText") {
                org.jetbrains.compose.web.dom.Text("Brigitte Tohm")
            }
            org.jetbrains.compose.web.dom.Text(" on ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText") {
                org.jetbrains.compose.web.dom.Text("Unsplash")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("kotlin-fun-new-language") }) {
        org.jetbrains.compose.web.dom.Text("Kotlin — Fun new language")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1DvIYrgwJ9EfAYv_JeL74nA.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Kotlin — Android")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Developers were tired of boilerplate and the challenges with Java language and couple of years back, few companies and developers were looking at choices of languages available to build Android apps; that’s when they came across Kotlin.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Since then the adoption of this ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("beautiful language")
        }
        org.jetbrains.compose.web.dom.Text(" kept on increasing. Fast-forward to May 17' ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Google announced Kotlin as official language")
        }
        org.jetbrains.compose.web.dom.Text(" for Android.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We all now what happened later ;) Moar Kotlin!")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Still haven’t learned Kotlin? There are lot of resources available. I personally recommend ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/u/a199eb0fa9a0") {
                org.jetbrains.compose.web.dom.Text("Antonio Leiva")
            }
            org.jetbrains.compose.web.dom.Text("’s blog, videos on ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://caster.io/courses/introduction-to-kotlin") {
                org.jetbrains.compose.web.dom.Text("caster.io")
            }
            org.jetbrains.compose.web.dom.Text(" and several talks by ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/u/8ddd94878165") {
                org.jetbrains.compose.web.dom.Text("Jake Wharton")
            }
            org.jetbrains.compose.web.dom.Text(" or Christina Lee and many others like ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://youtu.be/TmNs8xLpUkE?t=3s") {
                org.jetbrains.compose.web.dom.Text("one by me")
            }
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Fun Fact: More than 17% of the projects in Android Studio 3.0 are now using Kotlin")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1brXROU28ZjW6T8NmmsHqpg.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Kotlin Adoption")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("kotlin-style-guide") }) {
        org.jetbrains.compose.web.dom.Text("Kotlin Style Guide")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("With Kotlin’s adoption rising like a forest fire 🔥. Google and Kotlin team at JetBrains released style guide containing ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("set of rules")
        }
        org.jetbrains.compose.web.dom.Text(" to follow while building Android apps with Kotlin.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://android.github.io/kotlin-guides/index.html") {
            org.jetbrains.compose.web.dom.Text("Home")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("android-architecture-components") }) {
        org.jetbrains.compose.web.dom.Text("Android Architecture Components")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/141h6EIkQ7dcNcPruu8j5Ow.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Previously, Google never gave their opinion or recommended which Architecture to use to build Android apps.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("But this year they finally decided to recommend what architecture to use with ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://developer.android.com/arch") {
            org.jetbrains.compose.web.dom.Text("Architecture Components and Guidelines")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("architecture-guidelines") }) {
        org.jetbrains.compose.web.dom.Text("Architecture Guidelines")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/guide.html") {
            org.jetbrains.compose.web.dom.Text("Architecture Guidelines")
        }
        org.jetbrains.compose.web.dom.Text(" is a set of guidelines defining the actual architecture and best practices to build robust, maintainable and testable Android apps.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("architecture-components") }) {
        org.jetbrains.compose.web.dom.Text("Architecture Components")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Architecture Components are bunch of libraries designed to help us build apps following the Architecture Guidelines. These libraries are modular so it’s not necessary to use all of them.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("They were announced at Google I/O 17' and now they have become ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("stable")
        }
        org.jetbrains.compose.web.dom.Text(" so now is the perfect time to try them out if you didn’t before.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I have written a series of articles explaining Architecture Components and a sample app to using them.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Blog post series:")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://android.jlelse.eu/introduction-to-android-architecture-components-22b8c84f0b9d") {
            org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Talk video:")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.youtube.com/embed/nYbX6BNF9oA?feature=oembed") {
            org.jetbrains.compose.web.dom.Text("Watch on YouTube")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Disclaimer: This one is by me. You can check out one by Google if you want")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Sample app:")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/AkshayChordiya/android-arch-news-sample/") {
            org.jetbrains.compose.web.dom.Text("AkshayChordiya/android-arch-news-sample")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Fun fact: More libraries (which will be part of Architecture Components) will be coming pretty soon.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("android-oreo-the-sweetest-android") }) {
        org.jetbrains.compose.web.dom.Text("Android Oreo — The sweetest Android")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1H_KAc8TqtAvQww7QF06p3Q.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Android Oreo")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This year we were gifted with Android Oreo which so many features. Oreo put an end background services continuously running in the background and eating memory.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-s-new") }) {
        org.jetbrains.compose.web.dom.Text("What’s new?")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Background Limit")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notification Channel")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Auto-fill API")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Picture-in-picture")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Adaptive icons")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Fonts and downloadable fonts")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Auto-sizing TextView")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Read more about API changes at:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/about/versions/oreo/android-8.0.html") {
            org.jetbrains.compose.web.dom.Text("Android 8.0 Features and APIs | Android Developers")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("android-studio-3-0") }) {
        org.jetbrains.compose.web.dom.Text("Android Studio 3.0")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Studio 3.0 was announced with many new features like Kotlin support, new suite of app monitoring tools which are more developer friendly and quickly help to fix the performance issues.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Key improvements:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("More faster")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Kotlin support")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("New app monitoring tools")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("APK Analyzer")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Instant app support")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Android things support")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Adaptive icons, downloadable fonts and much more")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can read more about it at:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://android-developers.googleblog.com/2017/10/android-studio-30.html") {
            org.jetbrains.compose.web.dom.Text("Android Studio 3.0")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("While Android 3.0 got stable, on the other hand Android 3.1 was released into canary channel bringing couple of more magic tricks✨ like new DEX compiler")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("instant-apps-native-apps-without-installation") }) {
        org.jetbrains.compose.web.dom.Text("Instant apps — Native apps without installation")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/instant-apps/index.html") {
            org.jetbrains.compose.web.dom.Text("Android Instant Apps")
        }
        org.jetbrains.compose.web.dom.Text(" are a new way to run Android apps without requiring installation. It’s a ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("whole new way")
        }
        org.jetbrains.compose.web.dom.Text(" for users to consume Android apps.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The instant apps are triggered by an URL which opens app without an installation. This is done by breaking the app into ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("features")
        }
        org.jetbrains.compose.web.dom.Text(" and having each feature mapped to URL and whenever Google Play receives a request for a particular URL it fetches the required code for that feature of the app and runs the app.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("anatomy-of-an-instant-app") }) {
        org.jetbrains.compose.web.dom.Text("Anatomy of an Instant app")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Instant app is composed of multiple features which are dependent on a base feature — which contains common logic for all the multiple features.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1-yWWiJhzFl-V4N5x2FQP4g.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Developing Instant apps helps to make the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("project modular")
        }
        org.jetbrains.compose.web.dom.Text(" (if it wasn’t before) ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("based upon features")
        }
        org.jetbrains.compose.web.dom.Text(" of the app and it also helps to cut down on APK size.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Great way to start building your Instant app:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/instant-apps/index.html") {
            org.jetbrains.compose.web.dom.Text("Android Instant Apps | Android Developers")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("project-treble") }) {
        org.jetbrains.compose.web.dom.Text("Project Treble")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android version ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("fragmentation")
        }
        org.jetbrains.compose.web.dom.Text(" is one of the biggest issue with the Android Ecosystem. It takes a lot of months for devices to receive the latest Android updates and most of devices don’t even receive updates.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("With Project Treble, the Android OS architecture is ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("re-designed")
        }
        org.jetbrains.compose.web.dom.Text(" to make it easier, faster and less costly for manufacturers to update devices to a new version of Android.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now with Treble, the device manufacturers just need to update the Android OS framework to the latest one without worrying about the vendor implementation which caused the delayed updates.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/15J20dC8thsbRet3LmOMUuA.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Project Treble Diagram")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It will take time for Project Treble to show it’s magic. I really hope it shines 🌟and solves the Android fragmentation problem to a greater extent.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://android-developers.googleblog.com/2017/05/here-comes-treble-modular-base-for.html") {
            org.jetbrains.compose.web.dom.Text("Here comes Treble: A modular base for Android")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Fun Fact: Google Pixel 2 comes with 3 years of promise for Android OS updates. It is the proof of what difference Project Treble will bring to Android Fragmentation.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("android-go-powerful-experience-for-entry-level-devices") }) {
        org.jetbrains.compose.web.dom.Text("Android Go — Powerful experience for entry-level devices")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1Cx63J3QtNv6JhU8ia3W_1Q.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Android Oreo (Go edition)")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://android-developers.googleblog.com/2017/05/whats-new-in-android-o-developer.html") {
            org.jetbrains.compose.web.dom.Text("Android Go")
        }
        org.jetbrains.compose.web.dom.Text(" is an initiative by Google to optimize the Android experience for billions of people coming online around the world.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It’s a customized version of Android designed to work great on an ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("entry-level device")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Go starts with Android 8.1 aka Android Oreo (Go edition) and it comes with following configuration:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Memory optimizations:")
            }
            org.jetbrains.compose.web.dom.Text(" Improved memory usage across the platform to ensure that apps can run efficiently on devices with 1GB or less RAM.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Google Play:")
            }
            org.jetbrains.compose.web.dom.Text(" Google Play store will promote or give more visibility to apps optimized to provide a great experience for billions of people with the ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/develop/quality-guidelines/building-for-billions.html") {
                org.jetbrains.compose.web.dom.Text("building for billions guidelines")
            }
            org.jetbrains.compose.web.dom.Text(". That said other apps will be shown and can be installed from the Store.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("features") }) {
        org.jetbrains.compose.web.dom.Text("Features")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Android Go devices will have 2x more storage apps")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("They will ship with “Go edition” of Google apps")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("On an average apps will be 15% faster")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Go was released in December at Solve for India and devices with Android Go configuration will be coming out in 2018:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.blog.google/products/android/introducing-android-oreo-go-edition/") {
            org.jetbrains.compose.web.dom.Text("Introducing Android Oreo (Go edition) with the release of Android 8.1")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("arcore") }) {
        org.jetbrains.compose.web.dom.Text("ARCore")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/2017-year-in-a-review-android/1wZlfNq5lRZSf1xvystFpDA.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("ARCore")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This year Augmented reality (AR) comes to Android with ARCore. It is a platform for building augmented reality apps on Android.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It is designed to work on wide variety of Android devices running Android 7.1 (Nougat) or above. But as of now it supports Pixel and some of Samsung devices as it’s in the developer preview.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It supports 3 development environments:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Java")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Unity")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Unreal")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("And probably few more in the pipeline. You can use any one of them to build apps using ARCore.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("It is still in developer preview and a great time to play with it")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Go ahead and start playing with AR")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developers.google.com/ar/") {
            org.jetbrains.compose.web.dom.Text("ARCore - Google Developers | ARCore | Google Developers")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("AR Stickers in Google Pixel 2 are of the example of ARCore on Android")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("neural-net-api") }) {
        org.jetbrains.compose.web.dom.Text("Neural Net API")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Neural Net API is an Android C API designed to perform on-device machine learning which run computational intensive operations.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It provides a base layer of abstraction for higher level machine learning frameworks like TensorFlow Lite, etc. It enables hardware-accelerated inference operations on supported devices to quickly execute previously trained machine learning models.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It will mainly help in:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Reducing the network cost and latency")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Provide privacy")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It is available on Android 8.1 (Oreo) and above.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Read more:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/ndk/guides/neuralnetworks/index.html") {
            org.jetbrains.compose.web.dom.Text("Neural Networks API | Android Developers")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("tensorflow-lite") }) {
        org.jetbrains.compose.web.dom.Text("TensorFlow Lite")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Machine Learning is on rise and ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/tensorflow/tensorflow") {
            org.jetbrains.compose.web.dom.Text("TensorFlow")
        }
        org.jetbrains.compose.web.dom.Text(" is one of the top open-source framework for Machine Learning and Deep Learning on GitHub.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("TensorFlow Lite is TensorFlow optimized for Mobile")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It’s a lightweight solution for mobile and embedded devices. It enables on-device machine learning inference with low latency and a small binary size. It also supports hardware acceleration with the new ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/ndk/guides/neuralnetworks/index.html") {
            org.jetbrains.compose.web.dom.Text("Android Neural Networks API")
        }
        org.jetbrains.compose.web.dom.Text(" introduced in Android 8.1.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("features-2") }) {
        org.jetbrains.compose.web.dom.Text("Features")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Lightweight:")
            }
            org.jetbrains.compose.web.dom.Text(" It enables on-device machine learning models with a small binary size and fast initialization/startup")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Cross-platform:")
            }
            org.jetbrains.compose.web.dom.Text(" It’s designed to run on Android and iOS both")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Fast:")
            }
            org.jetbrains.compose.web.dom.Text(" It has several optimizing for mobile devices, including dramatically improved model loading times, and supporting hardware acceleration")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Read more:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.tensorflow.org/mobile/tflite/") {
            org.jetbrains.compose.web.dom.Text("Introduction to TensorFlow Lite | TensorFlow")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("summary") }) {
        org.jetbrains.compose.web.dom.Text("Summary")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I feel 2017 was one of the most exciting years for Android with so many amazing announcements and Google making life of Android Developer easy using Kotlin and Architecture Components — Guidelines.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Making Android — Faster, Secure and Sweet with the release of Android Oreo and trying to solve the fragmentation problem using Project Treble and launching Android Go for entry-level devices.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Making the devices smarter and fun by bringing Machine Learning and Augmented Reality to Android with the help of the new Neural Net API and ARCore.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In a nutshell, I see a very bright future for Android, Kotlin and in turn for Android Developers and I feel many more exciting things to come forward in 2018.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("PS: If I missed something then kindly let me know in the comments and I’ll update the post. Thanks!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/87c27c6bd6c8dea21c9726d9564b27d6/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com/2017-year-in-a-review-android-5f2cd8738790") {
            org.jetbrains.compose.web.dom.Text("2017 year in a review: Android")
        }
        org.jetbrains.compose.web.dom.Text(" was originally published in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com") {
            org.jetbrains.compose.web.dom.Text("ProAndroidDev")
        }
        org.jetbrains.compose.web.dom.Text(" on Medium, where people are continuing the conversation by highlighting and responding to this story.")
    }
}
